import update from "immutability-helper";
import {BroadcastActions} from "../actions/Broadcast";

export const initialState = () => {
  return {
    options: {},
    client: null,
    remoteStreams: {},
    params: {},
    sub: null,
    messages: {},
  }
}

const broadcast = (state = initialState(), action) => {
  switch (action.type) {
    case BroadcastActions.SET_ATTRIBUTE:
      return update(state, { [action.key]: { $set: action.value } });
    case BroadcastActions.RESET_STATE:
      return update(state, {$set: initialState()});
    case BroadcastActions.ADD_REMOTE_STREAM:
      return update(state, { remoteStreams: { [action.id]: { $set: action.value } } });
    case BroadcastActions.REMOVE_REMOTE_STREAM:
      return update(state, { remoteStreams: { $unset: [action.id] } });
    case BroadcastActions.ADD_MESSAGE:
      return update(state, {
        messages: { // autivivification trick
          [action.value.storageKey] :
            chat => update(chat || [], { $push: [{ source: action.key, message: action.value.message }] })
        } });
    default:
      return state;
  }
};

export default broadcast;
